import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function PersonalisedOffersIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        d="M21.1294 8.59559V7.08259C21.1294 5.02159 19.4584 3.35059 17.3964 3.35059H16.1914"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M3.86914 8.59559V7.08259C3.86914 5.02159 5.54014 3.35059 7.60214 3.35059H8.83814"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M21.1294 12.8047V16.8787C21.1294 18.9407 19.4584 20.6117 17.3964 20.6117H16.1914"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M3.86914 12.8047V16.8787C3.86914 18.9407 5.54014 20.6117 7.60214 20.6117H8.83814"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6985 6.92308C11.5868 6.92308 10.6856 7.81851 10.6856 8.92308C10.6856 10.0276 11.5868 10.9231 12.6985 10.9231C13.8102 10.9231 14.7114 10.0276 14.7114 8.92308C14.7114 7.81851 13.8102 6.92308 12.6985 6.92308ZM9.7566 8.92308C9.7566 7.30871 11.0738 6 12.6985 6C14.3233 6 15.6405 7.30871 15.6405 8.92308C15.6405 10.5374 14.3233 11.8462 12.6985 11.8462C11.0738 11.8462 9.7566 10.5374 9.7566 8.92308Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1782 14C9.88 14 8.82757 15.0457 8.82757 16.3356C8.82757 16.4033 8.84003 16.4511 8.85309 16.479C8.86411 16.5025 8.87357 16.5092 8.88146 16.5134C9.24246 16.7086 10.2546 17.0769 12.6985 17.0769C15.1424 17.0769 16.1546 16.7086 16.5156 16.5134C16.5235 16.5092 16.533 16.5025 16.544 16.479C16.557 16.4511 16.5695 16.4033 16.5695 16.3356C16.5695 15.0457 15.5171 14 14.2188 14H11.1782ZM7.89854 16.3356C7.89854 14.5359 9.36691 13.0769 11.1782 13.0769H14.2188C16.0302 13.0769 17.4985 14.5359 17.4985 16.3356C17.4985 16.666 17.3782 17.098 16.9597 17.3242C16.4053 17.624 15.2161 18 12.6985 18C10.181 18 8.99177 17.624 8.43741 17.3242C8.01892 17.098 7.89854 16.666 7.89854 16.3356Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6985 6.92308C11.5868 6.92308 10.6856 7.81851 10.6856 8.92308C10.6856 10.0276 11.5868 10.9231 12.6985 10.9231C13.8102 10.9231 14.7114 10.0276 14.7114 8.92308C14.7114 7.81851 13.8102 6.92308 12.6985 6.92308ZM9.7566 8.92308C9.7566 7.30871 11.0738 6 12.6985 6C14.3233 6 15.6405 7.30871 15.6405 8.92308C15.6405 10.5374 14.3233 11.8462 12.6985 11.8462C11.0738 11.8462 9.7566 10.5374 9.7566 8.92308Z"
        stroke="currentColor"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1782 14C9.88 14 8.82757 15.0457 8.82757 16.3356C8.82757 16.4033 8.84003 16.4511 8.85309 16.479C8.86411 16.5025 8.87357 16.5092 8.88146 16.5134C9.24246 16.7086 10.2546 17.0769 12.6985 17.0769C15.1424 17.0769 16.1546 16.7086 16.5156 16.5134C16.5235 16.5092 16.533 16.5025 16.544 16.479C16.557 16.4511 16.5695 16.4033 16.5695 16.3356C16.5695 15.0457 15.5171 14 14.2188 14H11.1782ZM7.89854 16.3356C7.89854 14.5359 9.36691 13.0769 11.1782 13.0769H14.2188C16.0302 13.0769 17.4985 14.5359 17.4985 16.3356C17.4985 16.666 17.3782 17.098 16.9597 17.3242C16.4053 17.624 15.2161 18 12.6985 18C10.181 18 8.99177 17.624 8.43741 17.3242C8.01892 17.098 7.89854 16.666 7.89854 16.3356Z"
        stroke="currentColor"
        strokeWidth="0.5"
        fill="transparent"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconWrapper>
  );
}
